// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1x_l4","detailsBorder":"styles_detailsBorder__3maP4"};